import { Component } from "react";

import { UserOverview } from "../../../users/components/Users.Overview.Component";

// markup

export default class UserDetails extends Component {
  render() {
    let template;
    let accountInfo = this.props.accountInfo;

    if (accountInfo && accountInfo.fetched) {
      template = (
        <UserOverview
          currentUser={accountInfo.data}
          bankAccountId={this.props.application.BankAccountId}
        />
      );
    } else {
      template = (
        <div style={{ cursor: "pointer" }}>
          {accountInfo && accountInfo.fetching ? "Loading..." : undefined}
        </div>
      );
    }

    return <div>{template}</div>;
  }
}
